/**
 * overlay-autohide.js
 *
 * Fades out floating third-party overlays (Pandectes cookie widget,
 * Shopify Inbox chat bubble) once the footer scrolls into view, so they
 * stop covering the newsletter form, menus and policy links.
 *
 * They come back as soon as the footer leaves the viewport.
 * Purely visual - consent and chat still work normally, and nothing is
 * hidden while the cookie consent banner itself is still open.
 *
 * Deliberately avoids transform/layout changes and only touches the class
 * when the state actually flips, so it cannot contribute to scroll jitter.
 */
(function () {
  'use strict';

  var HIDE_CLASS = 'overlays-tucked';
  var SELECTORS = [
    '#pandectes-widget',
    '.pandectes-widget',
    '[id^="pandectes-widget"]',
    '#ShopifyChat',
    '#shopify-chat',
    '[id^="ShopifyChat"]',
    '.shopify-chat-container'
  ];

  var hiddenRules = SELECTORS.map(function (sel) {
    return 'body.' + HIDE_CLASS + ' ' + sel;
  }).join(',\n');

  var baseRules = SELECTORS.join(',\n');

  var style = document.createElement('style');
  style.textContent =
    hiddenRules +
    ' {\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n' +
    baseRules +
    ' {\n  transition: opacity .25s ease;\n}\n' +
    '@media (prefers-reduced-motion: reduce) {\n' +
    baseRules +
    ' {\n  transition: none;\n}\n}\n';

  function consentBannerOpen() {
    var banner = document.querySelector('#pandectes-banner, [id^="pandectes-banner"]');
    if (!banner) return false;
    return banner.offsetParent !== null;
  }

  function init() {
    document.head.appendChild(style);

    var footer = document.querySelector('footer');
    if (!footer || !('IntersectionObserver' in window)) return;

    var tucked = false;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        var shouldTuck = entry.isIntersecting && !consentBannerOpen();

        if (shouldTuck === tucked) return;
        tucked = shouldTuck;

        if (shouldTuck) {
          document.body.classList.add(HIDE_CLASS);
        } else {
          document.body.classList.remove(HIDE_CLASS);
        }
      },
      { rootMargin: '0px 0px -25% 0px', threshold: 0 }
    );

    observer.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
